import styled from 'styled-components'

export default styled.p`
  font-weight: 600;
  font-size: 18px;
  color: ${(props) => props.theme.clientColors.primary};
`
